import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api, V1 } from "@/lib/api";
import { BookOpen, ArrowRight, Sparkles } from "lucide-react";

const ICONS = { erken_kayit: "🎓", bursluluk: "💰", yaz_okulu: "☀️", donem_kayit: "📅" };

export default function RecentArticlesWidget() {
  const [items, setItems] = useState([]);

  useEffect(() => {
    api.get(`${V1}/articles/recent?limit=6`).then((r) => setItems(r.data || [])).catch(() => {});
  }, []);

  if (items.length === 0) return null;

  return (
    <section className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 py-16 md:py-24 border-t border-border">
      <div className="flex items-end justify-between gap-4 flex-wrap mb-10">
        <div>
          <div className="overline text-accent mb-2 flex items-center gap-1">
            <Sparkles className="h-3 w-3" /> Okul Rehberi
          </div>
          <h2 className="font-display text-3xl md:text-4xl font-bold tracking-tight">
            Aday veliler için taze rehber makaleler
          </h2>
          <p className="text-muted-foreground mt-2 max-w-2xl">
            Bursluluk, erken kayıt, yaz okulu ve dönem kayıt bilgileri — okul bazında güncel içeriklerle karar verin.
          </p>
        </div>
      </div>
      <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
        {items.map((a) => (
          <Link
            key={a.id}
            to={`/okul/${a.school_slug}/makale/${a.slug}`}
            className="group rounded-xl border border-border bg-card overflow-hidden hover:border-primary/40 transition"
            data-testid={`recent-article-${a.id}`}
          >
            {a.school_cover && (
              <div className="aspect-[16/9] overflow-hidden bg-muted">
                <img src={a.school_cover} alt={a.school_name} className="w-full h-full object-cover group-hover:scale-105 transition duration-500" />
              </div>
            )}
            <div className="p-5">
              <div className="text-xs text-muted-foreground flex items-center gap-1">
                <BookOpen className="h-3 w-3" />
                {a.school_name} · {a.school_province}
              </div>
              <div className="mt-2 flex items-start gap-2">
                <span className="text-2xl">{ICONS[a.type] || "📄"}</span>
                <div className="font-display font-bold text-lg leading-snug group-hover:text-primary transition">{a.title}</div>
              </div>
              {a.excerpt && <div className="text-sm text-muted-foreground line-clamp-2 mt-2">{a.excerpt}</div>}
              <div className="mt-4 text-sm text-primary font-medium flex items-center gap-1">
                Devamını Oku <ArrowRight className="h-3.5 w-3.5 group-hover:translate-x-1 transition" />
              </div>
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
}
